import {
    Card,
    CardContent,
    Grid,
    Skeleton,
    Stack,
    Typography,
} from '@mui/material';

const DetailsCardSkeleton = () => {
    return (
        <Grid item xs={12} md={6}>
            <Card>
                <CardContent>
                    <Typography variant="h6">
                        <Skeleton variant="text" width={150} />
                    </Typography>
                    <Stack spacing={1.5} sx={{ mt: 2 }}>
                        <Skeleton variant="text" width="90%" />
                        <Skeleton variant="text" width="80%" />
                        <Skeleton variant="text" width="70%" />
                        <Skeleton
                            variant="rectangular"
                            width="60%"
                            height={20}
                        />
                    </Stack>
                </CardContent>
            </Card>
        </Grid>
    );
};

export default DetailsCardSkeleton;
